import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import { useEffect } from "react";

export const useVisibilityChangeEvent = (
  callback: (visibilityState: DocumentVisibilityState, event: Event) => void
) => {
  const callbackRef = useEffectEvent(callback);

  useEffect(() => {
    const handleOnEvent = (event: Event) => {
      callbackRef(getWindowOrThrow().document.visibilityState, event);
    };

    getWindowOrThrow().addEventListener("visibilitychange", handleOnEvent);

    return () => {
      getWindowOrThrow().removeEventListener("visibilitychange", handleOnEvent);
    };
  }, [callbackRef]);
};
